<i18n>
{
  "fr": {
    "jurisdiction-other-placeholder": "Préciser la juridiction"
  },
  "en": {
    "jurisdiction-other-placeholder": "Specify jurisdiction"
  }
}
</i18n>

<template>
  <div>
    <b-select
      expanded
      :placeholder="placeholder"
      :value="value"
      @input="onCodeChange"
    >
      <option v-for="item in jurisdictions" :key="item.value" :value="item.value">{{ item.text }}</option>
    </b-select>
    <b-input
      v-if="isOther"
      class="mt-2"
      :value="otherValueDisplay"
      :placeholder="$t('jurisdiction-other-placeholder')"
      maxlength="100"
      @input="$emit('update:otherValue', $event)"
      @blur="$emit('other-blur')"
    />
  </div>
</template>

<script>
import JurisdictionService from '@/services/jurisdiction'

export default {
  name: 'JurisdictionSelect',
  props: {
    value: {
      type: String,
      default: null
    },
    otherValue: {
      default: null,
      validator: (value) => value === null || typeof value === 'string'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    jurisdictions() {
      return JurisdictionService.getAllJurisdictions()
    },
    isOther() {
      return JurisdictionService.isOtherJurisdiction(this.value)
    },
    otherValueDisplay() {
      return this.otherValue == null ? '' : this.otherValue
    }
  },
  methods: {
    onCodeChange(code) {
      this.$emit('input', code)
      if (!JurisdictionService.isOtherJurisdiction(code)) {
        this.$emit('update:otherValue', null)
      }
      this.$emit('change', code)
    }
  }
}
</script>
